import React from 'react';
import { Input, Button, Message, Form } from '@gasbuddy/react-components';
import shared from '../../styles/shared.css';

const {
  api,
  getParameterByName,
  redirectAndKeepCurrentParams,
  testPasswordRules,
} = require('../../../lib/bputils').default;

let typingPasswordTimer;
let typingPasswordVerifyTimer;
const doneTypingInterval = 500;

class ResetPasswordForm extends React.Component {
  static propTypes = {
  }

  static defaultProps = {
  }

  constructor(props) {
    super(props);
    this.state = {
      password: '',
      passwordVerify: '',
      isNotValidPassword: false,
      isNotMatchingPassword: false,
      isLoading: false,
      hasError: false,
      passwordReset: false,
    };
    this.handlePasswordKeyUp = this.handlePasswordKeyUp.bind(this);
    this.handlePasswordKeyDown = this.handlePasswordKeyDown.bind(this);
    this.handlePasswordVerifyKeyUp = this.handlePasswordVerifyKeyUp.bind(this);
    this.handlePasswordVerifyKeyDown = this.handlePasswordVerifyKeyDown.bind(this);
  }

  componentDidMount = () => {
    this.autofocusedInput.focus();
    this.PasswordMinLength = 6;
    this.PasswordMinLengthMsg = 'Please enter at least 6 characters.';
    this.PasswordRegexMsg = 'Must contain 1 uppercase character and 1 digit';
    this.PasswordMismatchMsg = 'Password does not match';
  }

  handleSubmit = (e) => {
    const self = this;
    e.preventDefault();
    this.setState({ isLoading: true });
    const { password } = this.state;

    api.post({
      path: `/users/reset-password/${getParameterByName('t')}`,
      data: { password },
    })
      .then(() => {
        self.setState({ isLoading: false, passwordReset: true });
        window.setTimeout(() => redirectAndKeepCurrentParams('/login.html'), 2000);
      })
      .catch(() => self.setState({ isLoading: false, hasError: true }));
  }

  validateAndSetPassword = (newPassword) => {
    const isValidPassword = testPasswordRules(newPassword);
    this.setState({ password: newPassword, isNotValidPassword: !isValidPassword });
  }

  validateAndSetPasswordVerify = (newPasswordVerify, password) => {
    const equalPasswords = (password === newPasswordVerify);
    this.setState({ passwordVerify: newPasswordVerify, isNotMatchingPassword: !equalPasswords });
  }

  handlePasswordKeyUp = (e) => {
    clearTimeout(typingPasswordTimer);
    const newPassword = e.target.value;
    typingPasswordTimer = setTimeout(() => this.validateAndSetPassword(newPassword), doneTypingInterval);
  }

  handlePasswordKeyDown = () => {
    clearTimeout(typingPasswordTimer);
  }

  handlePasswordVerifyKeyUp = (e) => {
    clearTimeout(typingPasswordVerifyTimer);
    const { password } = this.state;
    const newPasswordVerify = e.target.value;
    typingPasswordVerifyTimer = setTimeout(() => this.validateAndSetPasswordVerify(newPasswordVerify, password), doneTypingInterval);
  }

  handlePasswordVerifyKeyDown = () => {
    clearTimeout(typingPasswordVerifyTimer);
  }

  render() {
    const { isNotValidPassword, isNotMatchingPassword, password, passwordVerify, isLoading } = this.state;
    const showPasswordError = isNotValidPassword && password.length > 0;
    const showPasswordVerifyError = isNotMatchingPassword && passwordVerify.length > 0;
    const passwordErrorMessage = password.length >= this.PasswordMinLength ? this.PasswordRegexMsg : this.PasswordMinLengthMsg;
    const shouldDisableButton = (password.length === 0 || passwordVerify.length === 0 || showPasswordError || showPasswordVerifyError);
    const { hasError, passwordReset } = this.state;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Input
          placeholder="New Password"
          type="password"
          onBlur={this.handlePasswordKeyUp}
          onKeyUp={this.handlePasswordKeyUp}
          onKeyDown={this.handlePasswordKeyDown}
          autoComplete="off"
          error={showPasswordError ? passwordErrorMessage : undefined}
          ref={(e) => { this.autofocusedInput = e; }}
        />
        <Input
          placeholder="Re-enter New Password"
          type="password"
          onBlur={this.handlePasswordVerifyKeyUp}
          onKeyUp={this.handlePasswordVerifyKeyUp}
          onKeyDown={this.handlePasswordVerifyKeyDown}
          autoComplete="off"
          error={showPasswordVerifyError ? this.PasswordMismatchMsg : undefined}
        />

        { hasError ? (
          <Message color="red" style={{ textAlign: 'center' }} dismissable>
            {'Oops, we dropped the ball on that one. Our bad. Please give us another chance and try it again.'}
          </Message>
        ) : null }
        { passwordReset ? (
          <Message color="teal">
            {'Your new password has been saved.'}
          </Message>
        ) : null }

        <Button
          type="submit"
          rounded
          color="teal"
          className={shared.fullWidth}
          disabled={shouldDisableButton}
          loading={isLoading}
        >
          Save New Password
        </Button>
      </Form>
    );
  }
}

export default ResetPasswordForm;
